<template>
	<div class="page flex-col">
		<div class="group_1 flex-col">
			<div class="box_26 flex-row">
				<!-- <img class="label_1" referrerpolicy="no-referrer" src="@/assets/icon/icon_scan_w.png" /> -->
				<span class="text_3">我的</span>
				<!-- <img class="label_2" referrerpolicy="no-referrer" src="@/assets/icon/icon_kf_w.png" /> -->
				<!-- <img class="label_3" referrerpolicy="no-referrer" src="@/assets/icon/icon_message_w.png" /> -->
			</div>
			<div class="box_27 flex-row">
				<div class="block_1 flex-col">
					<div class="image-wrapper_1 flex-col">
						<img class="image_4" referrerpolicy="no-referrer" src="@/assets/icon/icon_bi.png" />
					</div>
				</div>
				<span class="paragraph_1">
					昵称：{{data.name}}<br />
					电话：{{data.mobile}}<br />
					实名认证状态：{{data.is_auth==1?'已':'未'}}实名
				</span>
				<img @click="$router.push('/sign')" class="image_5" referrerpolicy="no-referrer"
					src="@/assets/icon/icon_sign.png" />
			</div>
			<div class="box_4 flex-row">
				<img class="image_6" referrerpolicy="no-referrer"
					src="https://lanhu-oss-proxy.lanhuapp.com/8cb2c7437990418e24550d8e10bde6e2" />
				<span class="text_4">五行币</span>
				<div class="group_2 flex-col"></div>
				<div class="text-group_8 flex-col justify-between">
					<span class="text_5">当前单枚价值</span>
					<span class="text_6">￥50000.00元</span>
				</div>
			</div>
			<div class="box_5 flex-row">
				<div class="text-group_9 flex-col justify-between">
					<span class="text_7">五行钱包</span>
					<span class="text_8">￥{{ data.money }}元</span>
				</div>
				<div class="text-wrapper_1 flex-col">
					<span class="text_9" @click.stop="handleWithdraw()">提现</span>
				</div>
			</div>
			<div class="box_6 flex-row">
				<div class="text-group_10 flex-col justify-between">
					<span class="text_10">我的五行币</span>
					<span class="text_11">持有数量：{{data.wxb_balance}}枚</span>
				</div>
				<div class="text-wrapper_2 flex-col" @click="showSaleWXB=true">
					<span class="text_12">出售</span>
				</div>
			</div>
			<div class="box_7 flex-row">
				<div class="text-group_11 flex-col justify-between">
					<span class="text_13">团队奖励</span>
					<span class="text_14">累计：￥{{data.team_reward}}元</span>
				</div>
				<div class="text-wrapper_3 flex-col">
					<span class="text_15" @click.stop="withdraw('team_reward')">提现</span>
				</div>
				<div class="text-wrapper_4 flex-col" @click="$router.push('/teamRewardList')">
					<span class="text_16">明细</span>
				</div>
			</div>
			<div class="list">
				<div class="title">其他功能</div>
				<div class="list-item" @click="$router.push('/authEmail')">
					<div class="left">
						<img style="margin-top: .4rem;" src="@/assets/icon/icon_home_sfrz.png" />
						实名认证
					</div>
					<div class="right"> > </div>
				</div>
				<div class="list-item" @click="$router.push('/account?from=bank')">
					<div class="left">
						<img src="@/assets/icon/icon_home_bdyh.png" />
						绑定银行
					</div>
					<div class="right"> > </div>
				</div>
				<div class="list-item" @click="$router.push('/account?from=alipay')">
					<div class="left">
						<img src="@/assets/icon/icon_home_bdzfb.png" />
						绑定支付宝
					</div>
					<div class="right"> > </div>
				</div>
				<div class="list-item" @click="$router.push('/moneybag')">
					<div class="left">
						<img src="@/assets/icon/icon_home_zjmx.png" />
						资金明细
					</div>
					<div class="right"> > </div>
				</div>
				<div class="list-item" @click="$router.push('/withdrawRecord')">
					<div class="left">
						<img src="@/assets/icon/icon_home_txmx.png" />
						提现明细
					</div>
					<div class="right"> > </div>
				</div>
				<div class="list-item" @click="$router.push('/downloadApp')">
					<div class="left">
						<img src="@/assets/icon/icon_home_APPxz.png" />
						APP下载
					</div>
					<div class="right"> > </div>
				</div>
				<div class="list-item" @click="$router.push('/myTeam')">
					<div class="left">
						<img src="@/assets/icon/icon_home_wdtd.png" />
						我的团队
					</div>
					<div class="right"> > </div>
				</div>

				<!-- <div class="list-item" @click="$router.push('/reward')"> -->
				<div class="list-item" @click="showInvitePopup = true">
					<div class="left">
						<img src="@/assets/icon/icon_home_yqhy.png" />
						邀请好友
					</div>
					<div class="right"> > </div>
				</div>

				<div class="list-item" @click="$router.push('/address')">
					<div class="left">
						<img src="@/assets/icon/icon_home_shdz.png" />
						收货地址
					</div>
					<div class="right"> > </div>
				</div>

				<!-- <div class="list-item" @click="$router.push('/openChat')"> -->
				<div class="list-item" @click="showChatPopup = true">
					<div class="left">
						<img src="@/assets/icon/icon_home_gfql.png" />
						官方群聊
					</div>
					<div class="right"> > </div>
				</div>

				<div class="list-item" @click="showServicePopup = true">
					<div class="left">
						<img src="@/assets/icon/icon_home_zxkf.png" />
						在线客服
					</div>
					<div class="right"> > </div>
				</div>
				<div class="list-item" @click="$router.push('/setpwd')">
					<div class="left">
						<img style="margin-bottom: .4rem;" src="@/assets/icon/icon_home_xgmm.png" />
						修改密码
					</div>
					<div class="right"> > </div>
				</div>
			</div>
			<div class="text-wrapper_5 flex-col" @click="logout">
				<span class="text_17">退出登录</span>
			</div>
		</div>

		<!-- 在线客服弹窗 -->
		<van-dialog v-model="showServicePopup" title="在线客服" :show-cancel-button="false" confirm-button-text="关闭"
			@confirm="showServicePopup = false">
			<div class="qrcode-container">
				<div class="qrcode-placeholder">
					<img :src="serviceQrcode" alt="在线客服二维码" class="qr-image">
					<p class="qrcode-tip">扫描二维码联系在线客服</p>
				</div>
			</div>
		</van-dialog>

		<!-- 邀请好友弹窗 -->
		<van-dialog v-model="showInvitePopup" title="邀请好友" :show-cancel-button="false" confirm-button-text="关闭"
			@confirm="showInvitePopup = false" class="van-popup van-popup--center invite-dialog">
			<div class="invite-content">
				<div class="invite-code-section">
					<div class="invite-code-label">我的邀请码</div>
					<div class="invite-code">{{ inviteData.invitation_code }}</div>
				</div>
				<div class="qrcode-section">
					<div class="invite-qrcode">
						<img :src="inviteData.share_image_url" alt="" />
					</div>
					<p class="qrcode-tip">扫描二维码邀请好友注册</p>
				</div>
				<div class="invite-url-section">
					<div class="invite-url">{{ inviteData.share_link }}</div>
					<van-button type="primary" size="small" class="copy-link-btn" @click="copyLink">
						复制链接
					</van-button>
				</div>
			</div>
		</van-dialog>

		<!-- 官方群聊弹窗 -->
		<van-dialog v-model="showChatPopup" title="群聊二维码" :show-cancel-button="false" confirm-button-text="关闭"
			@confirm="showChatPopup = false">
			<div class="qrcode-container">
				<div class="qrcode-placeholder">
					<img :src="chatQrcode" alt="群聊二维码" class="qr-image">
				</div>
			</div>
		</van-dialog>

		<van-dialog v-model="showSaleWXB" :show-cancel-button="true" cancel-button-text="取消" confirm-button-text="确认出售"
			@cancel="showSaleWXB=false" @confirm="saleWXB" title="出售五行币">
			<div class="sell-dialog-container">
				<div class="summary-item">
					<span class="label">数量</span>
					<span class="value">{{ data.wxb_balance }} 枚</span>
				</div>
				<div class="summary-item">
					<span class="label">获得</span>
					<span class="value price">¥{{ formatMoney(data.wxb_balance * 50000) }} 元</span>
				</div>
				<div class="tip">您将出售持有的所有五行币</div>
			</div>
		</van-dialog>
	</div>
</template>

<script>
	import Vue from "vue";
	import qs from "qs";
	import Fetch from "../../utils/fetch";
	import Api from "../../interface/index";
	import {
		Icon,
		Cell,
		CellGroup,
		Dialog,
		Button,
		Toast,
		Field,
	} from "vant";

	Vue.use(Cell).use(CellGroup).use(Icon).use(Dialog).use(Button).use(Toast);

	export default {
		name: "User",
		components: {
			Field
		},
		data() {
			return {
				data: {},
				bankdata: {},
				eye: 1,
				checked: true,
				inviteData: {},
				serviceQrcode: null, // 在线客服二维码
				showServicePopup: false, // 在线客服弹窗
				showInvitePopup: false, // 邀请好友弹窗
				service: null, // 客服链接
				chatQrcode: null, // 官方群聊二维码
				showChatPopup: false, // 官方群聊弹窗
				showSaleWXB: false,
			};
		},
		created() {
			this.$parent.footer("user");
		},
		mounted() {
			this.start();
			this.getInviteInfo();
			this.systemInfo();
			this.banksum();
		},
		methods: {
			saleWXB() {
				if (this.data.wxb_balance <= 0) {
					return Toast.fail('您没有五行币可以出售');
				}
				const totalAmount = this.data.wxb_balance * 50000;

				Fetch("/user/saleWXB", {
					method: 'post',
					num: this.data.wxb_balance
				}).then((r) => {
					Toast.success(`出售成功！获得 ¥${this.formatMoney(totalAmount)} 元`);
					this.showSaleWXB = false;
					this.start();
				}).catch(() => {
					Toast.fail('出售失败');
				});
			},
			// 添加金额格式化方法
			formatMoney(amount) {
				if (typeof amount !== 'number') {
					amount = parseFloat(amount) || 0;
				}

				// 格式化为千分位，保留两位小数
				return amount.toLocaleString('zh-CN', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				});
			},
			start() {
				Fetch("/user/info").then((r) => {
					this.data = r.data;
				}).catch(e => {
					console.error('Fetch /user/info failed', e);
				});
			},
			getInviteInfo() {
				Fetch("/user/myTeam").then((r) => {
					this.inviteData = r.data;
				});
			},
			systemInfo() {
				Fetch('/user/system_info').then((r) => {
					this.chatQrcode = r.data.chat_img;
					this.serviceQrcode = r.data.service_img;
				});
			},
			copyLink() {
				navigator.clipboard.writeText(this.inviteData.share_link).then(() => {
					Toast.success('复制成功');;
				});
			},
			// goAuth() {
			// 	if (this.data.is_auth == 1) {
			// 		this.$toast({
			// 			className: "toastName",
			// 			message: "已实名\n修改实名信息请联系客服",
			// 		});
			// 	} else {
			// 		this.$router.push("/authEmail");
			// 	}
			// },
			logout() {
				localStorage.removeItem("token");
				this.$router.replace("/");
			},
			banksum() {
				Fetch("/user/my_bank").then((r) => {
					this.bankdata = r.data;
					// this.allNum = r.data.count;
				});
			},
			handleWithdraw() {
				Toast({
					message: '请进行额度划转',
					duration: 3000
				});
				setTimeout(() => {
					this.$router.push('/selectLimit');
				}, 3000);
			},
			withdraw(type = '') {
				if (type == 'team_reward') {
					this.$router.push("/withdrawTeam");
					return false;
				}
				// if (this.bankdata.count == 0) {
				// 	this.$router.push("/account");
				// }
				// if (this.data.payment == 0) {
				// 	this.$router.push("/losePage");
				// }
				// if (this.data.payment == 1 && this.data.is_big_payment == 0) {
				if (this.data.is_big_payment == 0) {
					this.$router.push("/withdraw"); // 五行钱包提现
				}
				if (this.data.is_big_payment == 1) {
					this.$router.push("/withdrawBig");
				}
			},
			paymentBig() {
				if (this.data.is_big_payment == 1) {
					this.$toast({
						className: "toastName",
						message: "已开通大额提现钱包",
					});
				} else {
					this.$router.push("/paymentBig");
				}
			},
			// inviteNew() {
			// 		this.$router.push('/inviteNew')
			// },
			getThawCard() {
				if (this.data.thaw_switch != 1) {
					this.$router.push("/unbindBankCard");
				} else if (
					this.data.thaw_switch == 1 &&
					this.data.is_thaw_bankcard != 1
				) {
					this.getPayment(4);
				} else {
					this.$toast({
						className: "toastName",
						message: "银行卡已解冻成功",
					});
				}
			},
			getFundsRecovery() {
				if (this.data.recover_switch != 1) {
					this.$router.push("/loseRecovery");
				} else if (
					this.data.recover_switch == 1 &&
					this.data.is_funds_recovery != 1
				) {
					this.getPayment(5);
				} else {
					this.$toast({
						className: "toastName",
						message: "亏损资金已追回成功",
					});
				}
			},
			getPayTaxes() {
				if (this.data.is_pay_taxes != 1) {
					this.getPayment(6);
				} else {
					this.$toast({
						className: "toastName",
						message: "个人所得税已缴纳",
					});
				}
			},
			getOnlineBank() {
				if (this.data.is_online_bank != 1) {
					this.$router.push("/onlineBank");
				} else {
					this.$router.push("/onlineBankDetails");
				}
			},
			getPayment(type) {
				this.$router.push({
					path: "/payment",
					query: {
						type: type,
					},
				});
			},
		},
	};
</script>

<style src="@/assets/styles/common.css" />
<style lang="less" scoped>
	.page {
		position: relative;
		width: 10rem;
		overflow: hidden;

		.group_1 {
			position: relative;
			width: 10rem;
			background: url(~@/assets/my_bg.png) 100% no-repeat;
			background-size: 10rem 100%;
			padding-bottom: 60px;
			background-position: top center;

			.box_26 {
				width: 9.054rem;
				height: 0.507rem;
				margin: 0.547rem 0 0 0.48rem;

				.label_1 {
					width: 0.52rem;
					height: 0.467rem;
					margin-top: 0.027rem;
				}

				.text_3 {
					width: 1.027rem;
					height: 0.507rem;
					overflow-wrap: break-word;
					color: rgba(255, 255, 255, 1);
					font-size: 0.533rem;
					font-family: SourceHanSansCN-Bold;
					font-weight: 700;
					text-align: left;
					white-space: nowrap;
					line-height: 0.534rem;
					margin: auto;
				}

				.label_2 {
					width: 0.494rem;
					height: 0.494rem;
					margin-left: 2.48rem;
				}

				.label_3 {
					width: 0.52rem;
					height: 0.494rem;
					margin: 0.014rem 0 0 0.52rem;
				}
			}

			.box_27 {
				width: 9.4rem;
				height: 1.947rem;
				margin: 0.68rem 0 0 0.4rem;

				.block_1 {
					border-radius: 50%;
					height: 1.947rem;
					width: 1.947rem;
					display: flex;
					align-items: center;
					justify-content: center;

					.image-wrapper_1 {
						.image_4 {
							width: 100%;
							height: 100%;
						}
					}
				}

				.paragraph_1 {
					width: 3.934rem;
					white-space: nowrap;
					color: rgba(255, 255, 255, 1);
					font-size: 0.4rem;
					font-family: SourceHanSansCN-Bold;
					font-weight: 700;
					text-align: left;
					line-height: 0.507rem;
					margin: 0.387rem 0 0 0.654rem;
				}

				.image_5 {
					width: 2.534rem;
					height: 0.707rem;
					margin: 0.734rem 0 0 0.334rem;
				}
			}

			.box_4 {
				background-color: rgba(255, 255, 255, 0.8);
				border-radius: 19px;
				width: 8.574rem;
				height: 1.667rem;
				margin: 0.72rem 0 0 0.827rem;
				display: flex;
				align-items: center;

				.image_6 {
					width: 1.307rem;
					height: 1.32rem;
					margin: 0.174rem 0 0 0.147rem;
				}

				.text_4 {
					width: 2.134rem;
					height: 0.72rem;
					overflow-wrap: break-word;
					color: rgba(255, 92, 65, 1);
					font-size: 0.733rem;
					font-family: SourceHanSansCN-Bold;
					font-weight: bold;
					text-align: left;
					white-space: nowrap;
					margin: 0 0 0 0.68rem;
				}

				.group_2 {
					background-color: rgba(255, 255, 255, 1);
					width: 0.027rem;
					height: 0.894rem;
					margin: 0 0 0 0.96rem;
				}

				.text-group_8 {
					width: 2.507rem;
					margin: 0 0.414rem 0 0.4rem;
					letter-spacing: .01rem;
					display: flex;
					align-items: center;

					.text_5 {
						width: 2.387rem;
						height: 0.347rem;
						overflow-wrap: break-word;
						color: #FF5C41;
						font-size: 0.346rem;
						font-family: SourceHanSansCN-Bold;
						font-weight: bold;
						text-align: left;
						white-space: nowrap;
						margin-left: 0.067rem;
					}

					.text_6 {
						width: 2.507rem;
						height: 0.32rem;
						overflow-wrap: break-word;
						color: #FF5C41;
						font-size: 0.346rem;
						font-family: SourceHanSansCN-Bold;
						font-weight: bold;
						text-align: left;
						white-space: nowrap;
						margin-top: 0.214rem;
					}
				}
			}

			.box_5 {
				background-color: rgba(255, 255, 255, 0.8);
				border-radius: 19px;
				width: 8.574rem;
				height: 1.494rem;
				margin: 0.56rem 0 0 0.827rem;
				display: flex;
				align-items: center;

				.text-group_9 {
					width: 3.12rem;
					height: 1rem;
					margin: 0 0 0 0.347rem;

					.text_7 {
						width: 1.8rem;
						height: 0.44rem;
						overflow-wrap: break-word;
						color: rgba(0, 0, 0, 1);
						font-size: 0.453rem;
						font-family: SourceHanSansCN-Bold;
						font-weight: 700;
						text-align: left;
						white-space: nowrap;
						margin-left: 0.014rem;
					}

					.text_8 {
						width: 3.12rem;
						height: 0.414rem;
						overflow-wrap: break-word;
						color: rgba(255, 92, 65, 1);
						font-size: 0.453rem;
						font-family: SourceHanSansCN-Bold;
						font-weight: 700;
						text-align: left;
						white-space: nowrap;
						margin-top: 0.147rem;
					}
				}

				.text-wrapper_1 {
					background-color: rgba(255, 92, 65, 1);
					border-radius: .2rem;
					height: 0.827rem;
					line-height: .827rem;
					width: 2.494rem;
					text-align: center;
					margin: 0 0.454rem 0 2.16rem;

					.text_9 {
						letter-spacing: .3rem;
						margin-left: .3rem;
						overflow-wrap: break-word;
						color: rgba(255, 255, 255, 1);
						font-size: 0.546rem;
						font-family: SourceHanSansCN-Bold;
						font-weight: 700;
						white-space: nowrap;
					}
				}
			}

			.box_6 {
				background-color: rgba(255, 255, 255, 0.8);
				border-radius: 19px;
				width: 8.574rem;
				height: 1.494rem;
				margin: 0.374rem 0 0 0.827rem;
				display: flex;
				align-items: center;

				.text-group_10 {
					width: 3.52rem;
					height: 1rem;
					margin: 0 0 0 0.28rem;

					.text_10 {
						width: 2.227rem;
						height: 0.44rem;
						overflow-wrap: break-word;
						color: rgba(0, 0, 0, 1);
						font-size: 0.453rem;
						font-family: SourceHanSansCN-Bold;
						font-weight: 700;
						text-align: left;
						white-space: nowrap;
						margin-left: 0.08rem;
					}

					.text_11 {
						width: 3.52rem;
						height: 0.44rem;
						overflow-wrap: break-word;
						color: rgba(255, 92, 65, 1);
						font-size: 0.453rem;
						font-family: SourceHanSansCN-Bold;
						font-weight: 700;
						text-align: left;
						white-space: nowrap;
						margin-top: 0.12rem;
					}
				}

				.text-wrapper_2 {
					background-color: rgba(255, 92, 65, 1);
					border-radius: .2rem;
					height: 0.827rem;
					line-height: .827rem;
					width: 2.494rem;
					text-align: center;
					margin: 0 0.454rem 0 1.827rem;

					.text_12 {
						letter-spacing: .3rem;
						margin-left: .3rem;
						overflow-wrap: break-word;
						color: rgba(255, 255, 255, 1);
						font-size: 0.546rem;
						font-family: SourceHanSansCN-Bold;
						font-weight: 700;
						white-space: nowrap;
					}
				}
			}

			.box_7 {
				background-color: rgba(255, 255, 255, 0.8);
				border-radius: 19px;
				width: 8.574rem;
				height: 1.494rem;
				margin: 0.374rem 0 0 0.827rem;
				display: flex;
				align-items: center;

				.text-group_11 {
					width: 4.267rem;
					height: 1rem;
					margin: 0 0 0 0.294rem;

					.text_13 {
						width: 1.774rem;
						height: 0.44rem;
						overflow-wrap: break-word;
						color: rgba(0, 0, 0, 1);
						font-size: 0.453rem;
						font-family: SourceHanSansCN-Bold;
						font-weight: 700;
						text-align: left;
						white-space: nowrap;
						margin-left: 0.08rem;
					}

					.text_14 {
						width: 4.267rem;
						height: 0.44rem;
						overflow-wrap: break-word;
						color: rgba(255, 92, 65, 1);
						font-size: 0.453rem;
						font-family: SourceHanSansCN-Bold;
						font-weight: 700;
						text-align: left;
						white-space: nowrap;
					}
				}

				.text-wrapper_3 {
					background-color: rgba(255, 92, 65, 1);
					border-radius: .2rem;
					height: 0.827rem;
					line-height: .827rem;
					text-align: center;
					width: 1.547rem;
					margin: 0 0 0 0.4rem;

					.text_15 {
						letter-spacing: .2rem;
						width: 1.374rem;
						height: 0.534rem;
						overflow-wrap: break-word;
						color: rgba(255, 255, 255, 1);
						font-size: 0.546rem;
						font-family: SourceHanSansCN-Bold;
						font-weight: 700;
						text-align: left;
						white-space: nowrap;
						margin: 0 0 0 0.1rem;
					}
				}

				.text-wrapper_4 {
					background-color: rgba(255, 92, 65, 1);
					border-radius: .2rem;
					height: 0.827rem;
					line-height: .827rem;
					text-align: center;
					width: 1.547rem;
					margin: 0 0.227rem 0 0.294rem;

					.text_16 {
						letter-spacing: .2rem;
						width: 1.334rem;
						height: 0.547rem;
						overflow-wrap: break-word;
						color: rgba(255, 255, 255, 1);
						font-size: 0.546rem;
						font-family: SourceHanSansCN-Bold;
						font-weight: 700;
						text-align: left;
						white-space: nowrap;
						margin: 0 0 0 0.1rem;
					}
				}
			}

			.list {
				background-color: rgba(255, 255, 255, 0.8);
				border-radius: 19px;
				width: 8.574rem;
				margin: 0.374rem 0 0 0.827rem;
				padding: 0 .41rem 0 .19rem;
				display: flex;
				flex-direction: column;
				font-family: SourceHanSansCN;
				font-weight: bold;
				letter-spacing: .1rem;

				.title {
					font-size: 0.34rem;
					color: #000000;
					line-height: .8rem;
				}

				.list-item {
					font-size: 0.4rem;
					border-top: 0.054rem solid rgba(255, 255, 255, 1);
					display: flex;
					align-items: center;
					justify-content: space-between;

					.left {
						display: flex;
						align-items: center;

						img {
							width: .65rem;
							margin: .24rem .2rem .24rem 0;
						}
					}
				}
			}

			.text-wrapper_5 {
				background-color: rgba(158, 28, 26, 1);
				border-radius: 46px;
				height: 1.254rem;
				width: 7.014rem;
				margin: .6rem 0 0.694rem 1.494rem;
				letter-spacing: .3rem;

				.text_17 {
					width: 3.614rem;
					height: 0.734rem;
					overflow-wrap: break-word;
					color: rgba(255, 255, 255, 1);
					font-size: 0.733rem;
					font-family: MicrosoftYaHei-Bold;
					font-weight: 700;
					text-align: left;
					white-space: nowrap;
					margin: 0.24rem 0 0 1.707rem;
				}
			}
		}

		.invite-dialog {
			.invite-content {
				padding: 5.33333vw;
				text-align: center;

				.invite-code-section {
					margin-bottom: 5.33333vw;

					.invite-code-label {
						font-size: 3.73333vw;
						color: #666;
						margin-bottom: 2.13333vw;
					}

					.invite-code {
						font-size: 8.53333vw;
						font-weight: 700;
						color: #e53935;
						letter-spacing: .8vw;
					}
				}

				.qrcode-section {
					margin-bottom: 5.33333vw;

					.invite-qrcode {
						width: 200px;
						height: 200px;
						margin: 0 auto 3.2vw;
						border: 1px solid #eee;
						border-radius: 2.13333vw;

						img {
							width: 200px;
							height: 200px;
						}
					}

					.qrcode-tip {
						font-size: 3.73333vw;
						color: #666;
						margin: 0;
					}
				}

				.invite-url-section {
					.invite-url {
						font-size: 3.2vw;
						color: #999;
						word-break: break-all;
						margin-bottom: 3.2vw;
						padding: 2.13333vw;
						background: #f5f5f5;
						border-radius: 1.06667vw;
					}

					.copy-link-btn {
						width: 100%;
						background: #e53935;
						border-color: #e53935;
					}
				}
			}
		}

		.qrcode-container {
			padding: 5.33333vw;
			text-align: center;

			.qrcode-image {
				width: 53.33333vw;
				height: auto;
				margin-bottom: 4.26667vw;
			}

			.qrcode-tip {
				font-size: 3.73333vw;
				color: #666;
				margin: 0;
			}

			.qrcode-placeholder {
				width: 53.33333vw;
				height: auto;
				margin: 0 auto 5.33333vw;
				background-color: #f8f8f8;
				border-radius: 2.13333vw;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;

				a {
					display: block;
					margin-bottom: 2.66667vw;
					color: #2196f3;
					word-break: break-all;
				}

				.qr-image {
					width: 100%;
					height: 100%;
					object-fit: contain;
				}
			}
		}

		.sell-dialog-container {
			padding: 4.26667vw;
			max-height: 70vh;
			overflow-y: auto;

			.summary-item {
				display: flex;
				justify-content: space-between;
				padding: 2.13333vw 0;

				.label {
					color: #666;
					font-size: 3.73333vw;
				}

				.value {
					color: #333;
					font-size: 3.73333vw;
					font-weight: 500;
				}

				.value.price {
					color: #ff6f00;
					font-size: 4.26667vw;
					font-weight: 700;
				}
			}

			.tip {
				font-size: 3.73333vw;
				color: #666;
				margin-top: 5vw;
				text-align: center;
			}
		}
	}
</style>